import React from 'react'

const Manual_crear_plantilla_editor_email = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear Plantilla de eMail con el editor - Paso a Paso
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_Plantilla_de_eMail_con_el_editor__Paso_a_Paso__cWCq36BXQbqfzgcEkWDJZA?as=scrollable"
          className="scribe-iframe-general-80"
          width="100%"
          height="4800"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_crear_plantilla_editor_email
